const centerRoutes = [
  {
    path: '/center',
    name: 'center',
    component: () => import('@/views/center/center'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/center/user-integration',
    name: 'user-integration',
    component: () => import('@/views/center/user-integration'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/center/personal-data',
    name: 'personal-data',
    component: () => import('@/views/center/personal-data'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/userCoupon',
    name: 'userCoupon',
    component: () => import('@/views/center/user-coupon'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/orderDetail/:orderId',
    name: 'orderDetail',
    component: () => import('@/views/center/order-detail'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/center/personal-setting',
    name: 'personal-setting',
    component: () => import('@/views/center/personal-setting'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/receivingAddress',
    name: 'receivingAddress',
    component: () => import('@/views/center/receiving-address'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/center/update-key',
    name: 'update-key',
    component: () => import('@/views/center/update-key'),
    meta: {
      needLogin: true
    }
  },
  // 双十一活动地址
  {
    path: '/spikeAddress',
    name: 'spikeAddress',
    component: () => import('@/views/center/spike-address'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/spikeAddressNew',
    name: 'spikeAddressNew',
    component: () => import('@/views/center/spike-address-new'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/receivingAddressNew',
    name: 'receivingAddressNew',
    component: () => import('@/views/center/receiving-address-new'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/receivingAddressSub',
    name: 'receivingAddressSub',
    component: () => import('@/views/center/receiving-address-sub'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/center/update-general',
    name: 'update-general',
    component: () => import('@/views/center/update-general'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/center/reset-password',
    name: 'reset-password',
    component: () => import('@/views/center/reset-password')
  },
  {
    path: '/center/forget-password',
    name: 'forget-password',
    component: () => import('@/views/center/forget-password')
  },
  {
    path: '/center/staff-info',
    name: 'staff-info',
    component: () => import('@/views/center/staff-info'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/center/staff-data',
    name: 'staff-data',
    component: () => import('@/views/center/staff-data')
  },
  {
    path: '/userOrder',
    name: 'userOrder',
    component: () => import('@/views/center/user-order'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/center/staff-apply',
    name: 'staff-apply',
    component: () => import('@/views/center/staff-apply')
  },
  {
    path: '/orderCancel/:itemId/:orderId/:orderDetailId',
    name: 'orderCancel',
    component: () => import('@/views/center/order-cancel'),
    meta: {
      needLogin: true,
      needUserRole: true
    }
  },
  {
    path: '/center/workshop-change',
    name: 'workshop-change',
    component: () => import('@/views/center/workshop-change'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/center/workshop-transfer',
    name: 'workshop-transfer',
    component: () => import('@/views/center/workshop-transfer'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/center/workshop-transfer-select',
    name: 'workshop-transfer-select',
    component: () => import('@/views/center/workshop-transfer-select'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/activation_step_one',
    name: 'activation_step_one',
    component: () => import('@/views/center/activation_step_one')
  },
  {
    path: '/activation_step_two',
    name: 'activation_step_two',
    component: () => import('@/views/center/activation_step_two')
  },
  {
    path: '/activation_step_two_modification',
    name: 'activation_step_two_modification',
    component: () => import('@/views/center/activation_step_two_modification')
  },
  {
    path: '/activation_step_three',
    name: 'activation_step_three',
    component: () => import('@/views/center/activation_step_three')
  },
  {
    path: '/userCollection',
    name: 'userCollection',
    component: () => import('@/views/center/user-collection'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/help-center',
    name: 'help-center',
    component: () => import('@/views/center/help-center'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/site-agreement',
    name: 'site-agreement',
    component: () => import('@/views/center/site-agreement')
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('@/views/center/solution')
  },
  {
    path: '/solution1',
    name: 'solution1',
    component: () => import('@/views/center/solution1')
  },
  {
    path: '/manual',
    name: 'manual',
    component: () => import('@/views/center/manual')
  },

]

export default centerRoutes
